import React from 'react';
import { ActionIcon } from '@mummssoftware/common-ui';

export type StyledActionIconProps = {
  disabled?: boolean;
  onClick?: (e: any) => void;
  /* Icon component */
  Icon: React.ComponentType<any>;
  htmlColor?: string;
  iconColor?: string;
  id?: string;
};

export const styleIcon = {
  marginTop: 11,
  marginLeft: 2,
  marginRight: 0,
  width: 20,
  height: 20,
};

export const StyledActionIcon = ({
  Icon,
  disabled,
  htmlColor,
  onClick,
  id,
}: StyledActionIconProps) => (
  <ActionIcon
    Icon={Icon}
    htmlColor={htmlColor}
    style={styleIcon}
    disabled={disabled}
    onClick={onClick}
    id={id}
  />
);
